import React, { useEffect, useState,forwardRef  } from "react";
import { useSelector,useDispatch} from "react-redux";
import VIcon from "components/custom/Icon";
import { themeIcons } from "config/theme";
import { stringIsNullOrEmpty } from '../../util/Util'
import "../../assets/css/bannerapk.css";
import "../../assets/css/floatingchat.css";
import { useLocation } from 'react-router-dom';
import {
  WebUrl,
} from "../../util/Constant";
import { useTranslation } from "react-i18next";
import { showResponseMessage } from "redux/AppAction";

const BannerAPK = forwardRef(( props,ref ) => {
  var _dispatch = useDispatch();
  var { t } = useTranslation();
  var { heartBeat } = useSelector((state) => state.authState);
  
  const [shouldShowBannerAPK, setShouldShowBannerAPK] = useState(false);
  const [clickCloseBannerAPK, setClickCloseBannerAPK] = useState(false);
  const [bannerAPKImg,setBannerAPKImg]=useState("");
  const [bannerAPKUrl,setBannerAPKUrl]=useState("");

  const [iconColor, setIconColor] = useState('#FFF');
  const bannerAPK=useSelector((state)=>state.appState.bannerAPK);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();
  const { rewardRef, chatRef, dailyCheckInRef } = props;



	useEffect(() => {
    
		init();

    const parentElement = document.querySelector('.page-container');
    
    if(parentElement){
    const backgroundColor = window.getComputedStyle(parentElement).backgroundColor; 
    const isDarkTheme = isDarkBackground(backgroundColor);
    setIconColor(isDarkTheme ? '#FFF' : '#383838');
    }
    
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

	}, []);

  useEffect(() => {
    const reward = rewardRef?.current;
    const chat = chatRef?.current;
    const daily = dailyCheckInRef?.current;

    if (!reward || !chat) return;

    const rewardPos = shouldShowBannerAPK ? 2 : 1;
    const chatPos = shouldShowBannerAPK ? 3 : 2;
    const dailyPos = shouldShowBannerAPK ? 4 : 3;

    reward.changePos(rewardPos);
    chat.changePos(chatPos);
    if (daily && typeof daily.changePos === "function") {
      daily.changePos(dailyPos);
    }
  }, [shouldShowBannerAPK, rewardRef, chatRef, dailyCheckInRef]);

  useEffect(()=>{

    let bannerAPKIcon=bannerAPK;
   
    if(bannerAPKIcon){
      let newImageUrl = "";
      
      if (!stringIsNullOrEmpty(bannerAPKIcon?.desktopImage)){
        newImageUrl = bannerAPKIcon.desktopImage;
      }

      if(isMobile && !stringIsNullOrEmpty(bannerAPKIcon?.mobileImage)){
        newImageUrl = bannerAPKIcon.mobileImage;
      }
      
      // Only update if URL actually changed
      if(newImageUrl && newImageUrl !== bannerAPKImg){
        //console.log("desktop image changed from:", bannerAPKImg, "to:", newImageUrl)
        setBannerAPKImg(newImageUrl);
      } else {
        //console.log("desktop image unchanged:", bannerAPKImg)
      }
    }

  },[isMobile,bannerAPK])

  // useEffect(() => {
  //   init()
  // }, [heartBeat]);

  async function init() {

    let bannerAPKIcon=bannerAPK;
    
    if(bannerAPKIcon){
    if(!stringIsNullOrEmpty(bannerAPKIcon?.desktopImage) && isValidBannerUrl(bannerAPKIcon?.url)){

      setBannerAPKUrl(bannerAPKIcon.url);
      
      if(!clickCloseBannerAPK){
        setShouldShowBannerAPK(true);
      }

    }else{
      setShouldShowBannerAPK(false);
    } 
    }else{
      setShouldShowBannerAPK(false);
    }
  }

  function isValidBannerUrl(url) {
    try {
      if(stringIsNullOrEmpty(url)) return false;
      const parsedUrl = new URL(url);
      return ["http:", "https:"].includes(parsedUrl.protocol);
    } catch (e) {
      return false;
    }
  }

  const FILE_EXTENSIONS = [".apk", ".xapk", ".zip", ".exe", ".msi", ".dmg", ".pkg"];

  const getFileNameFromUrl = (url) => {
    try {
      const pathname = new URL(url).pathname;
      return decodeURIComponent(pathname.substring(pathname.lastIndexOf("/") + 1)) || "download";
    } catch {
      return "download";
    }
  };

  const openInNewTab = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const triggerDownload = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadAPK = async () => {
    if (!bannerAPKUrl) return;
    let bannerApkDownload=bannerAPK?.apkDownload;
 
    try {

      if (!bannerApkDownload) {
      openInNewTab(bannerAPKUrl);
      return;
      }
      const pathname = new URL(bannerAPKUrl).pathname.toLowerCase();
      const hasFileExt = FILE_EXTENSIONS.some((ext) => pathname.endsWith(ext));

      if (hasFileExt) {
        triggerDownload(bannerAPKUrl, getFileNameFromUrl(bannerAPKUrl));
        return;
      }

      let shouldDownload = false;

      try {
        const response = await fetch(bannerAPKUrl, {
          method: "HEAD",
          redirect: "follow"
        });

        if (response.ok) {
          const contentType = (response.headers.get("content-type") || "").toLowerCase();
          const contentDisposition = (response.headers.get("content-disposition") || "").toLowerCase();

          if (
            contentDisposition.includes("attachment") ||
            contentType.includes("application/vnd.android.package-archive") ||
            contentType.includes("application/octet-stream")
          ) {
            shouldDownload = true;
          }
        }
      } catch {
        // HEAD can fail due to CORS, fallback to open link.
      }
      if (shouldDownload) {
        triggerDownload(bannerAPKUrl, getFileNameFromUrl(bannerAPKUrl));
      } else {
        openInNewTab(bannerAPKUrl);
      }
    } catch {
      _dispatch(showResponseMessage(false, t("DOWNLOAD_APK_ERROR")));
    }
  };

  const [imgLoad, setImgLoad] = useState(false);

  useEffect(() => {
    if(bannerAPKImg){
      setImgLoad(true)
    }
  }, [bannerAPKImg]);

  // Removed component wrapper to prevent recreation on every render

  const isDarkBackground = (bgColor) => {
    const rgb = bgColor.match(/\d+/g);
    if (rgb) {
      const r = parseInt(rgb[0], 10);
      const g = parseInt(rgb[1], 10);
      const b = parseInt(rgb[2], 10);
      return (r * 0.299 + g * 0.587 + b * 0.114) < 128;
    }
    return false;
  };

  const CloseBtn = (props)=> (
    <div
          className="float-channel-close-button" style={{ color: iconColor }}
          onClick={(e) => {
              e.stopPropagation();
              setShouldShowBannerAPK(false);
              setClickCloseBannerAPK(true);
          }}
    >
      <VIcon icon={themeIcons.close} className="vicon" />
    </div>
  );

	return (
    <>
      {shouldShowBannerAPK && location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" && (
        <div id="banner-apk">
          <div 
          style={{ position: "relative", display: "inline-block",padding:"10px"}}
          onClick={handleDownloadAPK}>
             {imgLoad && <CloseBtn />}
            <img className="banner-apk-icon" alt="banner-apk-icon" src={bannerAPKImg} key={bannerAPKImg} />
          </div>
        </div>
      )}
    </>
	);
});

export default BannerAPK;
